(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('genericDataService', genericData);

    genericData.$inject = ['$http', '$q', 'endPoints', 'authorization'];

    /* jshint maxstatements:false */
    function genericData($http, $q, endPoints, authorization) {

        var DEFAULT_LIFETIME = 600000; //10 min

		var cache = {
			perfilesFlotaPorUsuario: {
				params: { userId: null },
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
			},
			perfilesFlota: {
				params: { empresaMasterId: null },
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
			},
            clients: {
                params: { company: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            empresas: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tarifas: {
                params: { clientId: null, type: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            productos: {
                params: { tarifaId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            marcas: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            modelos: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            paises: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            provincias: {
                params: {
                    clientId: null,
                    paisId: null
                },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            poblaciones: {
                params: {
                    clientId: null,
                    provinciaId: null
                },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            colectivos: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposFlota: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposSubFlota: {
                params: { tipoFlotaId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            colores: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposVhc: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposIncidencia: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            averias: {
                params: { tipoIncidenciaId: null, clienteId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            bases: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
			},
			sucursales: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
			},
            talleres: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            calendarios: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            ubicaciones: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            operarios: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            flota: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposFin: {
                params: { clientId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposPago: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            tiposOrdenLog: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            colaboradores: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            aseguradoras: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            contadores: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            informes: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            motRechazo: {
                params: { asegId: null },
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
            },
            comisiones: {
                list: null,
                lastUpdated: null,
                lifetime: DEFAULT_LIFETIME
			},
			grupos: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
			},
			tarifaProducto: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
            },
            tiposOrden: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
            },
            unidadesMedida: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
            },
            impuestos: {
				list: null,
				lastUpdated: null,
				lifetime: DEFAULT_LIFETIME
            },
            // address searcher cache

        };

        var service = {
            getClients: getClients,
            getEmpresas: getEmpresas,
            getEmpresasFromMaster: getEmpresasFromMaster,
            getColoresEstado: getColoresEstado,
            getColaboradores: getColaboradores,
			getTarifas: getTarifas,
			getComisiones: getComisiones,
            getProductos: getProductos,
            getVehicleBrands: getVehicleBrands,
            getVehicleModel: getVehicleModel,
            getPaises: getPaises,
            getProvinces: getProvinces,
            getPopulations: getPopulations,
            getEntidades: getEntidades,
            getEntidadesPersonalized: getEntidadesPersonalized,
            getColectivos: getColectivos,
            getTiposFlota: getTiposFlota,
            getTiposSubFlota: getTiposSubFlota,
            getVehicleColors: getVehicleColors,
            getTiposVhc: getTiposVhc,
            getTiposIncidencia: getTiposIncidencia,
            getTiposIncidencias: getTiposIncidencias,
            getAverias: getAverias,
			getBases: getBases,
            getSucursales: getSucursales,
            getCalendarios: getCalendarios,
            getTalleres: getTalleres,
            getUbicaciones: getUbicaciones,
            getOperarios: getOperarios,
            getFlota: getFlota,
            getTiposFin: getTiposFin,
            getTiposPago: getTiposPago,
            getTiposOrdenLog: getTiposOrdenLog,
            getAseguradoras: getAseguradoras,
            getContadores: getContadores,
            getInformes: getInformes,
      		addColor: addColor,
      		getPerfilesDeFlotaPorUsuario: getPerfilesDeFlotaPorUsuario,
      		getPerfilesDeFlota: getPerfilesDeFlota,
            getMotivosRechazo: getMotivosRechazo,
			getGrupos: getGrupos,
            tarifaProducto: tarifaProducto,
            getTiposOrden: getTiposOrden,
            getImpuestos: getImpuestos,
            getUnidadesMedida: getUnidadesMedida,
            // address cache
            getAddressSearcherData: getAddressSearcherData,
            getAddressSearcherCache: getAddressSearcherCache
        };

        //init
        (function () {
            //initialize();
        })();

        return service;

        //EXPOSED FUNCTIONS
        function getClients(company, refreshCache) {
            refreshCache = (typeof refreshCache === 'undefined') ? false : refreshCache;
            
            var expired = cache.clients.params.company !== company ||
                cache.clients.lastUpdated === null ||
                (Date.now() - cache.clients.lastUpdated) >= cache.clients.lifetime;

            var deferred = $q.defer();

            if (expired || refreshCache) {
                cache.clients.params.company = company;
                cache.clients.lastUpdated = Date.now();
                cache.clients.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'GetClients' + '?empresaId=' + company
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.clients.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.clients.lastUpdated = null;
                    });

                return deferred.promise;
            } 

            if(cache.clients.list){
                deferred.resolve(cache.clients.list.slice());
                return deferred.promise;
            }else{
                return cache.clients.deferred.promise;
            }
        }


        function getEmpresas(refreshCache) {
            refreshCache = (typeof refreshCache === 'undefined') ? false : refreshCache;

            var expired = refreshCache || cache.empresas.lastUpdated === null ||
                (Date.now() - cache.empresas.lastUpdated) >= cache.empresas.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.empresas.lastUpdated = Date.now();
                cache.empresas.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getEmpresas'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.empresas.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.empresas.lastUpdated = null;
                    });

                return deferred.promise;
            } 

            if(cache.empresas.list){
                deferred.resolve(cache.empresas.list.slice());
                return deferred.promise;
            }else{
                return cache.empresas.deferred.promise;
            }
        }

        function getEmpresasFromMaster() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getEmpresasFromMaster'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getColoresEstado() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getColoresEstado'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getEntidades() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getEntidades'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getEntidadesPersonalized() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getEntidadesPersonalized'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getCalendarios() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getCalendarios'
            };
            authorization.setBearerHeader($http);
            $http(request)
                .then(function (response) {
                    deferred.resolve(response.data.slice());
                },
                    function (response) {
                        deferred.reject(null);
                    });
            return deferred.promise;
        }

        function getColaboradores(refreshCache) {
            refreshCache = (typeof refreshCache === 'undefined') ? false : refreshCache;

            var expired = refreshCache || cache.colaboradores.lastUpdated === null ||
                (Date.now() - cache.colaboradores.lastUpdated) >= cache.colaboradores.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.colaboradores.lastUpdated = Date.now();
                cache.colaboradores.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getColaboradores'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.colaboradores.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.colaboradores.lastUpdated = null;
                    });

                return deferred.promise;
            } 

            if(cache.colaboradores.list){
                deferred.resolve(cache.colaboradores.list.slice());
                return deferred.promise;
            }else{
                return cache.colaboradores.deferred.promise;
            }
        }

        function getTarifas(clientId, type) {
            /*jshint maxcomplexity:false */
            var expired = cache.tarifas.params.clientId !== clientId || cache.tarifas.params.type !== clientId || cache.tarifas.lastUpdated === null || (Date.now() - cache.tarifas.lastUpdated) >= cache.tarifas.lifetime;

            var deferred = $q.defer();
            if (expired) {
                cache.tarifas.params.clientId = clientId;
                cache.tarifas.params.type = type;
                cache.tarifas.lastUpdated = Date.now();
                cache.tarifas.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTarifas' + '?clientId=' + clientId
                };

                if(type === 'GRU'){
					request.url = endPoints.genericData.getGenericData + 'getTarifasGru' + '?clientId=' + clientId;
                } else if(type === 'LOG'){
					request.url = endPoints.genericData.getGenericData + 'getTarifasLog' + '?clientId=' + clientId;
                } else if(type === 'TAX'){
                    request.url = endPoints.genericData.getGenericData + 'getTarifasTax' + '?clientId=' + clientId;
                }

                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tarifas.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tarifas.lastUpdated = null;
                    });
                return deferred.promise;
            }
            if(cache.tarifas.list){
                deferred.resolve(cache.tarifas.list.slice());
                return deferred.promise;
            } else {
                return cache.tarifas.deferred.promise;
            }
		}


		function tarifaProducto(tarifaId, productoId) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.genericData.getGenericData + 'getTarifaProducto',
				data: { 'tarifaId': tarifaId, 'productoId': productoId}
			};
			authorization.setBearerHeader($http);
			$http(request)
				.then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}


		function getComisiones() {
			var expired = cache.comisiones.lastUpdated === null ||
				(Date.now() - cache.comisiones.lastUpdated) >= cache.comisiones.lifetime;

                var deferred = $q.defer();

            if (expired) {
                cache.comisiones.lastUpdated = Date.now();
                cache.comisiones.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getComisiones'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.comisiones.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.comisiones.lastUpdated = null;
                    });
                return deferred.promise;
            }
            if(cache.comisiones.list){
                deferred.resolve(cache.comisiones.list.slice());
                return deferred.promise;
            }else{
                return cache.comisiones.deferred.promise;
            }
		}

        function getProductos(tarifaId) {
            var expired = cache.productos.params.tarifaId !== tarifaId ||
             cache.productos.lastUpdated === null ||
                (Date.now() - cache.productos.lastUpdated) >= cache.productos.lifetime;

            var deferred = $q.defer();
            
            if (expired) {
                cache.productos.params.tarifaId = tarifaId;
                cache.productos.lastUpdated = Date.now();
                cache.productos.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getProductos' + (tarifaId? '?tarifaId=' + tarifaId : '')
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.productos.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.productos.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.productos.list){
                deferred.resolve(cache.productos.list.slice());
                return deferred.promise;
            }else{
                return cache.productos.deferred.promise;
            }
        }

        function getVehicleBrands() {
            var expired = cache.marcas.lastUpdated === null ||
                (Date.now() - cache.marcas.lastUpdated) >= cache.marcas.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.marcas.lastUpdated = Date.now();
                cache.marcas.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getVehicleBrands'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.marcas.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.marcas.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.marcas.list){
                deferred.resolve(cache.marcas.list.slice());
                return deferred.promise;
            }else{
                return cache.marcas.deferred.promise;
            }
        }

        function getVehicleModel() {
            var expired = cache.modelos.lastUpdated === null ||
                (Date.now() - cache.modelos.lastUpdated) >= cache.modelos.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.modelos.lastUpdated = Date.now();
                cache.modelos.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getVehicleModel'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.modelos.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.modelos.lastUpdated = null;
                    });
                return deferred.promise;
            }
            if(cache.modelos.list){
                deferred.resolve(cache.modelos.list.slice());
                return deferred.promise;
            }else{
                return cache.modelos.deferred.promise;
            }
        }

        function getPaises(clientId) {
            var expired = cache.paises.params.clientId !== clientId ||
                cache.paises.lastUpdated === null ||
                (Date.now() - cache.paises.lastUpdated) >= cache.paises.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.paises.params.clientId = clientId;
                cache.paises.lastUpdated = Date.now();
                cache.paises.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getPaises' + '?clientId=' + clientId
                };

                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.paises.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.paises.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.paises.list){
                deferred.resolve(cache.paises.list.slice());
                return deferred.promise;
            }else{
                return cache.paises.deferred.promise;
            }
		}

		function getPerfilesDeFlota() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getPerfilesDeFlota'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
			
		}

		function getPerfilesDeFlotaPorUsuario(userId) {
			var expired = cache.perfilesFlotaPorUsuario.params.userId !== userId ||
				(Date.now() - cache.modelos.lastUpdated) >= cache.modelos.lifetime;

			var deferred = $q.defer();

			if (expired) {
				cache.perfilesFlotaPorUsuario.params.userId = userId;
				cache.perfilesFlotaPorUsuario.lastUpdated = Date.now();
				cache.perfilesFlotaPorUsuario.deferred = deferred;

				var request = {
					method: 'GET',
					url: endPoints.genericData.getGenericData + 'getPerfilesDeFlotaPorUsuario' + '?userId=' + userId
				};
				authorization.setBearerHeader($http);
				$http(request)
					.then(function (response) {
						cache.perfilesFlotaPorUsuario.list = response.data;
						deferred.resolve(response.data.slice());
					},
					function (response) {
						deferred.reject(null);
						cache.perfilesFlotaPorUsuario.lastUpdated = null;
					});
				return deferred.promise;
			}
			if (cache.perfilesFlotaPorUsuario.list) {
				deferred.resolve(cache.perfilesFlotaPorUsuario.list.slice());
				return deferred.promise;
			} else {
				return cache.perfilesFlotaPorUsuario.deferred.promise;
			}
		}

        function getProvinces(clientId, paisId) {
            var expired = cache.provincias.params.clientId !== clientId ||
                cache.provincias.params.paisId !== paisId ||
                cache.provincias.lastUpdated === null ||
                (Date.now() - cache.provincias.lastUpdated) >= cache.provincias.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.provincias.params.clientId = clientId;
                cache.provincias.params.paisId = paisId;
                cache.provincias.lastUpdated = Date.now();
                cache.provincias.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getProvinces' +
                        '?clientId=' + clientId + '&paisId=' + paisId
                };
                
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.provincias.list = response.data;
                        deferred.resolve(response.data);
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.provincias.lastUpdated = null;
                    });
                
                return deferred.promise;
            }

            if(cache.provincias.list){
                deferred.resolve(cache.provincias.list.slice());
                return deferred.promise;
            }else{
                return cache.provincias.deferred.promise;
            }
        }

        function getPopulations(clientId, provinceId) {
            var expired = cache.poblaciones.params.clientId !== clientId ||
                cache.poblaciones.params.provinciaId !== provinceId ||
                cache.poblaciones.lastUpdated === null ||
                (Date.now() - cache.poblaciones.lastUpdated) >= cache.poblaciones.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.poblaciones.params.clientId = clientId;
                cache.poblaciones.params.provinciaId = provinceId;
                cache.poblaciones.lastUpdated = Date.now();
                cache.poblaciones.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getPopulations' +
                        '?clientId=' + clientId + '&provinceId=' + provinceId
                };
                
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.poblaciones.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.poblaciones.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.poblaciones.list){
                deferred.resolve(cache.poblaciones.list.slice());
                return deferred.promise;
            }else{
                return cache.poblaciones.deferred.promise;
            }
        }

        function getAddressSearcherData(clientId) {
            var deferred = $q.defer();

            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getAddressSearcherData' +
                '/' + ((clientId != null) ? clientId : '00000000-0000-0000-0000-000000000000')
            };
            
            authorization.setBearerHeader($http);
            $http(request)
                .then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });

            return deferred.promise;
        }

        function getAddressSearcherCache(url) {
            var deferred = $q.defer();

            var request = {
                method: 'GET',
                url: endPoints.base + '/' + url
            };
            
            authorization.setBearerHeader($http);
            $http(request)
                .then(function (response) {
                    deferred.resolve(response.data);

                },
                function (response) {
                    deferred.reject(null);                    
                });

            return deferred.promise;
        }

        function getColectivos(clientId) {
            var expired = cache.colectivos.params.clientId !== clientId ||
                cache.colectivos.lastUpdated === null ||
                (Date.now() - cache.colectivos.lastUpdated) >= cache.colectivos.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.colectivos.params.clientId = clientId;
                cache.colectivos.lastUpdated = Date.now();
                cache.colectivos.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getColectivos' + '?clientId=' + clientId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.colectivos.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.colectivos.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.colectivos.list){
                deferred.resolve(cache.colectivos.list.slice());
                return deferred.promise;
            }else{
                return cache.colectivos.deferred.promise;
            }
        }

        function getTiposFlota() {
            var expired = cache.tiposFlota.lastUpdated === null ||
                (Date.now() - cache.tiposFlota.lastUpdated) >= cache.tiposFlota.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposFlota.lastUpdated = Date.now();
                cache.tiposFlota.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTipoFlota'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposFlota.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposFlota.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposFlota.list){
                deferred.resolve(cache.tiposFlota.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposFlota.deferred.promise;
            }
        }

        function getTiposSubFlota() {
            var expired = cache.tiposSubFlota.lastUpdated === null ||
                (Date.now() - cache.tiposSubFlota.lastUpdated) >= cache.tiposSubFlota.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposSubFlota.lastUpdated = Date.now();
                cache.tiposSubFlota.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTipoSubFlota'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposSubFlota.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposSubFlota.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposSubFlota.list){
                deferred.resolve(cache.tiposSubFlota.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposSubFlota.deferred.promise;
            }
        }

        function getVehicleColors(refreshCache) {
            refreshCache = (typeof refreshCache === 'undefined') ? false : refreshCache;

            var expired = refreshCache || cache.colores.lastUpdated === null ||
                (Date.now() - cache.colores.lastUpdated) >= cache.colores.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.colores.lastUpdated = Date.now();
                cache.colores.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getVehicleColors'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.colores.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.colores.lastUpdated = null;
                    });
                return deferred.promise;
            }
            if(cache.colores.list){
                deferred.resolve(cache.colores.list.slice());
                return deferred.promise;
            }else{
                return cache.colores.deferred.promise;
            }
        }

        function addColor(color){
            var deferred = $q.defer();

            var request = {
                method: 'POST',
                url: endPoints.genericData.getGenericData + 'AddVehicleColor',
                data: color
            };
            authorization.setBearerHeader($http);
            $http(request)
                .then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                    cache.clients.lastUpdated = null;
                });

            return deferred.promise;
        }

        function getTiposVhc(clientId) {
            var expired = cache.tiposVhc.params.clientId !== clientId ||
                cache.tiposVhc.lastUpdated === null ||
                (Date.now() - cache.tiposVhc.lastUpdated) >= cache.tiposVhc.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposVhc.params.clientId = clientId;
                cache.tiposVhc.lastUpdated = Date.now();
                cache.tiposVhc.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTipoVehicle' + '?clientId=' + clientId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposVhc.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposVhc.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposVhc.list){
                deferred.resolve(cache.tiposVhc.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposVhc.deferred.promise;
            }
        }

        function getTiposIncidencia(clientId) {
            var expired = cache.tiposIncidencia.params.clientId !== clientId ||
                cache.tiposIncidencia.lastUpdated === null ||
                (Date.now() - cache.tiposIncidencia.lastUpdated) >= cache.tiposIncidencia.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposIncidencia.params.clientId = clientId;
                cache.tiposIncidencia.lastUpdated = Date.now();
                cache.tiposIncidencia.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTipoIncidencia' + '?clientId=' + clientId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposIncidencia.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposIncidencia.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposIncidencia.list){
                deferred.resolve(cache.tiposIncidencia.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposIncidencia.deferred.promise;
            }
        }

        function getTiposIncidencias() {

            var deferred = $q.defer();
           
            var request = {
                method: 'GET',
                url: endPoints.genericData.getGenericData + 'getTiposIncidencias' 
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data.slice());
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getAverias(tipoIncidenciaId, clienteId) {
            var expired = cache.averias.params.tipoIncidenciaId !== tipoIncidenciaId ||
                cache.averias.params.clienteId !== clienteId ||
                cache.averias.lastUpdated === null ||
                (Date.now() - cache.averias.lastUpdated) >= cache.averias.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.averias.params.tipoIncidenciaId = tipoIncidenciaId;
                cache.averias.params.clienteId = clienteId;
                cache.averias.lastUpdated = Date.now();
                cache.averias.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getAverias' + 
                        '?tipoIncidenciaId=' + tipoIncidenciaId + '&clientId=' + clienteId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.averias.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.averias.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.averias.list){
                deferred.resolve(cache.averias.list.slice());
                return deferred.promise;
            }else{
                return cache.averias.deferred.promise;
            }
        }

        function getBases() {
            var expired = cache.bases.lastUpdated === null ||
                (Date.now() - cache.bases.lastUpdated) >= cache.bases.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.bases.lastUpdated = Date.now();
                cache.bases.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getBases'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.bases.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.bases.lastUpdated = null;
                    });
                return deferred.promise;
            } 

            if(cache.bases.list){
                deferred.resolve(cache.bases.list.slice());
                return deferred.promise;
            }else{
                return cache.bases.deferred.promise;
            }
		}

		function getSucursales(clientId) {
			var expired = cache.sucursales.lastUpdated === null ||
				(Date.now() - cache.sucursales.lastUpdated) >= cache.bases.lifetime;

			var deferred = $q.defer();

			if (expired) {
				cache.sucursales.lastUpdated = Date.now();
				cache.sucursales.deferred = deferred;

				var request = {
					method: 'GET',
					url: endPoints.genericData.getGenericData + 'getSucursales' + '?clientId=' + clientId
				};
				authorization.setBearerHeader($http);
				$http(request)
					.then(function (response) {
						cache.sucursales.list = response.data;
						deferred.resolve(response.data.slice());
					},
					function (response) {
						deferred.reject(null);
						cache.sucursales.lastUpdated = null;
					});
				return deferred.promise;
			}

			if (cache.sucursales.list) {
				deferred.resolve(cache.sucursales.list.slice());
				return deferred.promise;
			} else {
				return cache.sucursales.deferred.promise;
			}
		}

        function getTalleres() {
            var expired = cache.talleres.lastUpdated === null ||
                (Date.now() - cache.talleres.lastUpdated) >= cache.talleres.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.talleres.lastUpdated = Date.now();
                cache.talleres.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTalleres'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.talleres.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.talleres.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.talleres.list){
                deferred.resolve(cache.talleres.list.slice());
                return deferred.promise;
            }else{
                return cache.talleres.deferred.promise;
            }
        }

        function getUbicaciones(clientId) {
            var expired = cache.ubicaciones.params.clientId !== clientId ||
                cache.ubicaciones.lastUpdated === null ||
                (Date.now() - cache.ubicaciones.lastUpdated) >= cache.ubicaciones.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.ubicaciones.params.clientId = clientId;
                cache.ubicaciones.lastUpdated = Date.now();
                cache.ubicaciones.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getUbicaciones' + '?clientId=' + clientId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.ubicaciones.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.ubicaciones.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.ubicaciones.list){
                deferred.resolve(cache.ubicaciones.list.slice());
                return deferred.promise;
            }else{
                return cache.ubicaciones.deferred.promise;
            }
        }

        function getOperarios() {
            var expired = cache.operarios.lastUpdated === null ||
                (Date.now() - cache.operarios.lastUpdated) >= cache.operarios.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.operarios.lastUpdated = Date.now();
                cache.operarios.deferred = deferred;
                
                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getOperarios'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.operarios.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.operarios.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.operarios.list){
                deferred.resolve(cache.operarios.list.slice());
                return deferred.promise;
            }else{
                return cache.operarios.deferred.promise;
            }
        }

        function getFlota() {
            var expired = cache.flota.lastUpdated === null ||
                (Date.now() - cache.flota.lastUpdated) >= cache.flota.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.flota.lastUpdated = Date.now();
                cache.flota.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getFlota'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.flota.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.flota.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.flota.list){
                deferred.resolve(cache.flota.list.slice());
                return deferred.promise;
            }else{
                return cache.flota.deferred.promise;
            }
        }

        function getTiposFin(clientId) {
            var expired = cache.tiposFin.params.clientId !== clientId ||
                cache.tiposFin.lastUpdated === null ||
                (Date.now() - cache.tiposFin.lastUpdated) >= cache.tiposFin.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposFin.params.clientId = clientId;
                cache.tiposFin.lastUpdated = Date.now();
                cache.tiposFin.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTiposFin' + '?clientId=' + clientId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposFin.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposFin.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposFin.list){
                deferred.resolve(cache.tiposFin.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposFin.deferred.promise;
            }
        }

        function getTiposPago() {
            var expired = cache.tiposPago.lastUpdated === null ||
                (Date.now() - cache.tiposPago.lastUpdated) >= cache.tiposPago.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposPago.lastUpdated = Date.now();
                cache.tiposPago.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTiposPago'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposPago.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposPago.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposPago.list){
                deferred.resolve(cache.tiposPago.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposPago.deferred.promise;
            }
        }

        function getTiposOrdenLog() {
            var expired = cache.tiposOrdenLog.lastUpdated === null ||
                (Date.now() - cache.tiposOrdenLog.lastUpdated) >= cache.tiposOrdenLog.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposOrdenLog.lastUpdated = Date.now();
                cache.tiposOrdenLog.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTiposOrdenLog'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposOrdenLog.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposOrdenLog.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposOrdenLog.list){
                deferred.resolve(cache.tiposOrdenLog.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposOrdenLog.deferred.promise;
            }
        }

        function getAseguradoras() {
            var expired = cache.aseguradoras.lastUpdated === null ||
                (Date.now() - cache.aseguradoras.lastUpdated) >= cache.aseguradoras.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.aseguradoras.lastUpdated = Date.now();
                cache.aseguradoras.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getAseguradoras'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.aseguradoras.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.aseguradoras.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.aseguradoras.list){
                deferred.resolve(cache.aseguradoras.list.slice());
                return deferred.promise;
            }else{
                return cache.aseguradoras.deferred.promise;
            }
        }
        
		function getContadores(empresaId) {
			var deferred = $q.defer();
            var request = {
                method: 'GET',
				url: endPoints.genericData.getGenericData + 'getContadores' + '?empresaId=' + empresaId
            };
            authorization.setBearerHeader($http);
            $http(request)
                .then(function (response) {
                    deferred.resolve(response.data.slice());
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
		}

		function getGrupos() {
			var expired = cache.grupos.lastUpdated === null ||
				(Date.now() - cache.grupos.lastUpdated) >= cache.grupos.lifetime;

			var deferred = $q.defer();
			if (expired) {
				cache.grupos.lastUpdated = Date.now();
				cache.grupos.deferred = deferred;

				var request = {
					method: 'GET',
					url: endPoints.genericData.getGenericData + 'getGrupos'
				};
				authorization.setBearerHeader($http);
				$http(request)
					.then(function (response) {
						cache.grupos.list = response.data;
						deferred.resolve(response.data.slice());
					},
					function (response) {
						deferred.reject(null);
						cache.grupos.lastUpdated = null;
					});
				return deferred.promise;
			}
			if (cache.grupos.list) {
				deferred.resolve(cache.grupos.list.slice());
				return deferred.promise;
			} else {
				return cache.grupos.deferred.promise;
			}

		}

        function getInformes() {
            var expired = cache.informes.lastUpdated === null ||
                (Date.now() - cache.informes.lastUpdated) >= cache.informes.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.informes.lastUpdated = Date.now();
                cache.informes.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getInformes'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.informes.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.informes.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.informes.list){
                deferred.resolve(cache.informes.list.slice());
                return deferred.promise;
            }else{
                return cache.informes.deferred.promise;
            }
        }

        function getMotivosRechazo(asegId) {
            var expired = cache.motRechazo.params.asegId !== asegId ||
                cache.motRechazo.lastUpdated === null ||
                (Date.now() - cache.motRechazo.lastUpdated) >= cache.motRechazo.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.motRechazo.params.asegId = asegId;
                cache.motRechazo.lastUpdated = Date.now();
                cache.motRechazo.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getMotivosRechazo' + '?asegId=' + asegId
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.motRechazo.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.motRechazo.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.motRechazo.list){
                deferred.resolve(cache.motRechazo.list.slice());
                return deferred.promise;
            }else{
                return cache.motRechazo.deferred.promise;
            }
        }

        function getTiposOrden() {
            var expired = cache.tiposOrden.lastUpdated === null ||
                (Date.now() - cache.tiposOrden.lastUpdated) >= cache.tiposOrden.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.tiposOrden.lastUpdated = Date.now();
                cache.tiposOrden.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getTiposOrden'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.tiposOrden.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.tiposOrden.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.tiposOrden.list){
                deferred.resolve(cache.tiposOrden.list.slice());
                return deferred.promise;
            }else{
                return cache.tiposOrden.deferred.promise;
            }
        }

        function getUnidadesMedida() {
            var expired = cache.unidadesMedida.lastUpdated === null ||
                (Date.now() - cache.unidadesMedida.lastUpdated) >= cache.unidadesMedida.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.unidadesMedida.lastUpdated = Date.now();
                cache.unidadesMedida.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getUnidadesMedida'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.unidadesMedida.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.unidadesMedida.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.unidadesMedida.list){
                deferred.resolve(cache.unidadesMedida.list.slice());
                return deferred.promise;
            }else{
                return cache.unidadesMedida.deferred.promise;
            }
        }

        function getImpuestos() {
            var expired = cache.impuestos.lastUpdated === null ||
                (Date.now() - cache.impuestos.lastUpdated) >= cache.impuestos.lifetime;

            var deferred = $q.defer();

            if (expired) {
                cache.impuestos.lastUpdated = Date.now();
                cache.impuestos.deferred = deferred;

                var request = {
                    method: 'GET',
                    url: endPoints.genericData.getGenericData + 'getImpuestos'
                };
                authorization.setBearerHeader($http);
                $http(request)
                    .then(function (response) {
                        cache.impuestos.list = response.data;
                        deferred.resolve(response.data.slice());
                    },
                    function (response) {
                        deferred.reject(null);
                        cache.impuestos.lastUpdated = null;
                    });
                return deferred.promise;
            } 
            if(cache.impuestos.list){
                deferred.resolve(cache.impuestos.list.slice());
                return deferred.promise;
            }else{
                return cache.impuestos.deferred.promise;
            }
        }

        //PRIVATE FUNCTIONS
        function initialize(){
            //Initialize static data that needs no parameters 
            getClients();
            getEmpresas();
            getTarifas();
            getProductos();
            getVehicleBrands();
            getTiposFlota();
            getVehicleColors();
			getBases();
			getSucursales();
            getOperarios();
            getFlota();
            getTiposFin();
            getTiposPago();
        }
    }
})();